import viewportHelper from '@kissui/helpers/src/viewport.helpers'
import { stringifyForAttribute } from '@kissui/helpers/src/utils'

const DISPLAY_COLOR_MAX = 4

export const renderColors = props => {
    if (!props) {
        return ''
    }

    const {
        colors,
        sku,
        max_colors = DISPLAY_COLOR_MAX,
        a11y_extra_color = '',
        url,
        activeSku,
        name
    } = props

    if (!colors) {
        return ''
    }

    const colorData = stringifyForAttribute({
        colors,
        max_colors,
        activeSku: activeSku || sku,
        extra_url: url,
        extra_title: name + ', ' + a11y_extra_color
    })

    const size = viewportHelper.is.mobile ? 'small' : 'large'

    return `<nb-colors data="${colorData}" size="${size}"></nb-colors>`
}
